import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../../api/quarkusApi';

// Mensagens de WhatsApp enviadas pela clínica no período. As duas datas são inclusivas.
export function useSentMessages({ startDate, endDate }) {
  const navigate = useNavigate();

  const [messages, setMessages] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchMessages = useCallback(() => {
    if (!startDate || !endDate) return;
    setLoading(true);
    setError(null);
    quarkusApi
      .get('/whatsapp-messages', {
        headers: { Authorization: sessionStorage.getItem('token') },
        params: {
          initialDate: dayjsToApi(startDate),
          finalDate: dayjsToApi(endDate),
        },
      })
      .then((returnFromApi) => setMessages(returnFromApi.data ?? []))
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [startDate, endDate, navigate]);

  useEffect(() => {
    fetchMessages();
  }, [fetchMessages]);

  return { messages, isLoading, error, refetch: fetchMessages };
}

const dayjsToApi = (date) => date.format('DD/MM/YYYY');
